import Icon from '@/components/Icon/Icon';
import Menu, { MenuItem, SubMenu, ShareMenu } from '@/components/Menu/';
import NestLoading from '@/components/Loading/NestLoading';
import { noop, stopEvent, formatNumByK } from '@/utils/util';
import i18n from 'react-intl-universal';
import React, { Component } from 'react';
import classNames from 'classnames';

// page button tpl
const renderPageControl = (
  curPage,
  totalPage,
  styles,
  onPreBtnClick,
  onNextBtnClick,
) => {
  if (totalPage <= 1) { return null; }
  const preBtnClass = classNames({
    [styles['disabled']]: curPage <= 1,
  });
  const nextBtnClass = classNames({
    [styles['disabled']]: curPage >= totalPage,
  });
  return (
    <span className={styles['page-control']}>
      {
        <Icon
          name='chevron-circle-left'
          size='m'
          onClick={onPreBtnClick}
          className={preBtnClass}
        />
      }
      {curPage}/{totalPage}
      {
        <Icon
          name='chevron-circle-right'
          size='m'
          onClick={onNextBtnClick}
          className={nextBtnClass}
        />
      }
    </span>
  );
};

// 管理专题/最近专题
const renderCollectionItems = (
  data = [],
  isLoading,
  styles,
  text = {},
  onContributeBtnClick,
) => {
  return (
    <ul className={styles['collection-items']}>
      {
        isLoading && <NestLoading/>
      }
      {
        !isLoading && (data.length < 1) &&
        <div className={styles['empty']}>{i18n.get('error.data-empty')}</div>
      }
      {
        !isLoading && data.map((v, k) => {
          return (
            <li key={k}>
              <a
                className={styles['post-btn']}
                onClick={onContributeBtnClick}
                data-collection-id={v.id}
                data-post-text={text.postText}
                data-posting-text={text.postingText}
                data-posted-text={text.postedText}
              >
                {text.postText}
              </a>
              <img
                alt="png"
                src={v.avatar}
                thumbnail="180x180"
              />
              <span className={styles['collection-title']} title={v.title}>
                {v.title}
              </span>
            </li>
          );
        })
      }
    </ul>
  );
};

// 推荐专题/搜索专题, 底部点击加载更多的分页模式
const renderRecomendCollectionItems = (
  data = [],
  isLoading,
  styles,
  text = {},
  onContributeBtnClick,
  hasMore,
  onMoreDataBtnClick,
) => {
  return (
    <div>
      <ul className={styles['collection-items']}>
        {
          data.map((v, k) => {
            return (
              <li key={k} className={styles['rec-collection-item']}>
                <img
                  alt="png"
                  src={v.avatar}
                  thumbnail="180x180"
                />
                <span className={styles['collection-title']}>
                  {v.title}
                  <em>
                    {i18n.get('collections.note-num', { num: formatNumByK(v.notes_count) }) }，
                    {i18n.get('collections.suber-num', { num: formatNumByK(v.subscribers_count) }) }
                  </em>
                </span>
                <a
                  className={styles['post-btn']}
                  onClick={onContributeBtnClick}
                  data-collection-id={v.id}
                  data-post-text={text.postText}
                  data-posting-text={text.postingText}
                  data-posted-text={text.postedText}
                >
                  {text.postText}
                </a>
              </li>
            );
          })
        }
        {
          !isLoading && (data.length < 1) &&
          <div className={styles['empty']}>{i18n.get('error.data-empty')}</div>
        }
      </ul>
      {
        isLoading && <div className={styles['rec-loading-wrap']}><NestLoading/></div>
      }
      {
        !isLoading && (hasMore === true) &&
        <div
          className={styles['get-more']}
          onClick={onMoreDataBtnClick}
        >
          {i18n.get('publishSuccessModal.get-more-data')}
          {
            <Icon name='caret-down' size='m'/>
          }
        </div>
      }
      {
        !isLoading && (hasMore === false) && (data.length > 0) &&
        <div className={styles['no-more']}>{i18n.get('publishSuccessModal.no-more-data')} </div>
      }
    </div>
  );
};
const renderShareItems = (
  shareData,
  styles,
  icons = {},
  onWeiboShareBtnClick,
  onWechatShareBtnClick,
) => {
  return (
    <ul className={styles['share-items']}>
      <li className={styles['weibo']} onClick={onWeiboShareBtnClick}>
        <Icon name='weibo' className={styles['icon']}/>
        {i18n.get('share.to-weibo')}
      </li>
      <li className={styles['wechat']} onClick={onWechatShareBtnClick}>
        <Icon name='wechat' className={styles['icon']}/>
        {i18n.get('share.to-wechat')}
      </li>
      <li className={styles['copy-link']} data-clipboard-text={shareData.link}>
        <Icon name='link' className={styles['icon']}/>
        {i18n.get('share.copy-link')}
      </li>
      <ShareMenu
        text={i18n.get('share.more')}
        className={styles['more-share']}
        direction={''} // 取消方向icon
        filterItems={['weibo']}
        renderText
        shareData={shareData}
      />
    </ul>
  );
};
// 渲染我管理的专题模块
const renderEditableCoPage = (
  cachData,
  isLoading,
  styles,
  text = {},
  onContributeBtnClick,
  curEditableCoPageNum,
  totalEditableCoPage,
  onPreBtnClick,
  onNextBtnClick,
  newCollectionUrl,
) => {
  return (
    <div className={styles['collection-auto-page']}>
      <h3>
        {i18n.get('publishSuccessModal.my-collections')}
        <a href={newCollectionUrl}>
          {i18n.get('publishSuccessModal.new-collection')}
        </a>
        {
          renderPageControl(
            curEditableCoPageNum,
            totalEditableCoPage,
            styles,
            onPreBtnClick,
            onNextBtnClick,
          )
      }
      </h3>
      {
        renderCollectionItems(
          cachData,
          isLoading,
          styles,
          text,
          onContributeBtnClick,
        )
      }
    </div>
  );
};
// 渲染最近投稿的模块
const renderLatestCoPage = (
  cachData,
  isLoading,
  styles,
  text = {},
  onContributeBtnClick,
  curLatestCoPageNum,
  totalLatestCoPage,
  onPreBtnClick,
  onNextBtnClick,
) => {
  // 如果一条数据都没有直接返回null
  if (cachData[1] && cachData[1].length < 1) {
    return null;
  }
  return (
    <div className={styles['collection-auto-page']}>
      <h3>
        {i18n.get('publishSuccessModal.lastest-collections')}
        {
          renderPageControl(
            curLatestCoPageNum,
            totalLatestCoPage,
            styles,
            onPreBtnClick,
            onNextBtnClick,
          )
        }
      </h3>
      {
        renderCollectionItems(
          cachData[curLatestCoPageNum],
          isLoading,
          styles,
          text,
          onContributeBtnClick,
        )
      }
    </div>
  );
};
// 渲染推荐专题模块
const renderRecCoPage = (
  cachData,
  isLoading,
  styles,
  text = {},
  onContributeBtnClick,
  curRecCoPageNum,
  totalRecCoPage,
  onNextBtnClick,
) => {
  return (
    <div className={styles['collection-auto-page']}>
      <h3>
        {i18n.get('publishSuccessModal.recomend-collections')}
      </h3>
      {
        renderRecomendCollectionItems(
          cachData,
          isLoading,
          styles,
          text,
          onContributeBtnClick,
          curRecCoPageNum < totalRecCoPage,
          onNextBtnClick,
        )
      }
    </div>
  );
};

export default {
  renderPageControl,
  renderCollectionItems,
  renderRecomendCollectionItems,
  renderShareItems,
  renderLatestCoPage,
  renderRecCoPage,
  renderEditableCoPage,
};



// WEBPACK FOOTER //
// ./src/components/PublishSuccessModal/tpl.js